module.exports = __webpack_public_path__ + "img/culture_1.71b85d6b.png";